import { loadCookieYes } from '@/lib/consent/cookieYes';
import { useEffect } from 'react';
/**
 * Loads the cookie-consent banner on a public page. Only public pages without clinical data may
 * call this (sign-in, password reset, Link sign-up, Terms, Privacy); see ConsentScriptBoundary.
 */
export function useCookieConsentBanner() {
    useEffect(() => {
        loadCookieYes();
    }, []);
}
